export default "__VITE_ASSET__DKHWaczK__ 584w";